export default function Skills() {
  return (
    <section id="about" className="py-16 md:py-24 px-6 md:px-8 bg-white">
      <div className="max-w-7xl mx-auto rounded-3xl p-8 md:p-12 shadow-lg" style={{ backgroundColor: '#f2f6f8' }}>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-16 items-center">
          <div>
            <h2 className="text-3xl md:text-5xl font-bold mb-6 md:mb-8 text-gray-900">
              About Me
            </h2>
            <div className="space-y-4 md:space-y-5 text-gray-700">
              <p className="text-base md:text-lg leading-relaxed">
                I'm a Senior Product & UX Designer with over 8 years of experience crafting digital experiences that balance user needs with business goals. My approach combines strategic thinking with meticulous attention to detail.
              </p>
              <p className="text-base md:text-lg leading-relaxed">
                Throughout my career, I've had the privilege of working with startups and established companies across fintech, healthcare, and e-commerce sectors. I believe great design is invisible—it simply works.
              </p>
              <p className="text-base md:text-lg leading-relaxed">
                When I'm not designing, you'll find me exploring design systems, mentoring aspiring designers, or experimenting with new prototyping tools. I'm passionate about creating inclusive, accessible experiences that make a real difference in people's lives.
              </p>
            </div>
            <div className="mt-8 md:mt-10 flex flex-wrap gap-3">
              {['UX Design', 'Product Strategy', 'Design Systems', 'User Research', 'Prototyping', 'Figma', 'Accessibility'].map((skill) => (
                <span
                  key={skill}
                  className="px-4 py-2 bg-white rounded-full text-sm text-gray-800 border border-gray-200"
                >
                  {skill}
                </span>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="aspect-[4/5] rounded-3xl overflow-hidden bg-gray-200">
              <img
                src="https://static.readdy.ai/image/ed7d6e9501624c265bc1ac340fb9283d/9e298e98272b6454052af4ac8865b6ab.jpeg"
                alt="Okenna Okpareke - Senior Product & UX Designer"
                title="Okenna Okpareke - Senior Product & UX Designer"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 md:w-40 md:h-40 bg-[#FF6B4A] rounded-full opacity-20"></div>
            <div className="absolute -top-6 -left-6 w-24 h-24 md:w-32 md:h-32 bg-[#FF6B4A] rounded-full opacity-10"></div>
          </div>
        </div>

        <div className="mt-16 md:mt-20 grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {[
            { number: '8+', label: 'Years Experience' },
            { number: '50+', label: 'Projects Completed' },
            { number: '15+', label: 'Happy Clients' },
            { number: '3', label: 'Design Awards' }
          ].map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-3xl md:text-5xl font-bold text-[#FF6B4A] mb-2" style={{ fontFamily: 'DM Sans, sans-serif' }}>
                {stat.number}
              </div>
              <div className="text-sm md:text-base text-gray-600">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
